/**
 * 표 이름("1-1 일반사항")에서 주석 라벨을 만든다. 디자인은 번호만 쓴다("주석 1-1").
 * - 번호로 시작하면: "주석 <번호>"
 * - 번호가 없으면: 이름 그대로 ("주석 일반사항"은 어색하다)
 * - 이름을 아직 모르면(로딩/미선택): "현재 주석"
 */
export const toNoteLabel = (tableName?: string): string => {
  const name = tableName?.trim();
  if (!name) return "현재 주석";

  const number = name.match(/^\d+(?:-\d+)*/)?.[0];
  return number ? `주석 ${number}` : name;
};
